module.exports = __webpack_public_path__ + "static/media/box-full.5d3401bb.svg";